import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ethers } from "ethers";
import React from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import { SmallRegular } from "../../../styles/Fonts";
import { RewardProps } from "../index";

const RewardItem: React.FC<{
  reward: RewardProps;
  handleChange: (reward: RewardProps) => void;
  isSelected: boolean;
}> = ({ reward, handleChange, isSelected }) => {
  const {
    Rebate,
    Discount,
    RewardSession: { WeekNumber: weekNum, RewardToken: tokenSymbol },
    isClaimed,
  } = reward;

  return (
    <TierItemRow>
      <BoxIcon
        icon={isSelected ? faSquareCheck : faSquare}
        onClick={() => !isClaimed && handleChange(reward)}
        disabled={isClaimed}
      />
      <ValueText>{weekNum}</ValueText>
      <ValueText>{`${ethers.utils.formatUnits(
        +Rebate + +Discount,
        6
      )} ${tokenSymbol.toUpperCase()}`}</ValueText>
      <ValueText>{isClaimed ? "Claimed" : "Unclaimed"}</ValueText>
    </TierItemRow>
  );
};

export default RewardItem;

const TierRow = styled.div`
  display: grid;
  grid-template-columns: 40px 200px 200px 1fr;
  align-items: center;
  padding: 0 20px;
  @media (max-width: 768px) {
    grid-template-columns: 30px repeat(3, 1fr);
  }
`;

const TierItemRow = styled(TierRow)`
  padding: 16px 20px;
  background-color: ${Colors.backgroundGray4};
  border-radius: 8px;
`;

const ValueText = styled(SmallRegular)`
  font-size: 15px;
  line-height: 24px;
  color: ${Colors.ivory};
  @media (max-width: 768px) {
    font-size: 13px;
    line-height: 22px;
  }
`;

const BoxIcon = styled(FontAwesomeIcon)<{ disabled: boolean }>`
  font-size: 16px;
  color: ${Colors.ivory};
  cursor: ${(props) => (props.disabled ? "inherit" : "pointer")};
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
